import { h, Component } from 'preact';
import { accessNested, joinClasses, textToJsxArray } from 'utils/utils';
import { getCopy } from 'utils/copy';
import { getPrintYourTicketUrl } from 'store/ticketingPublic.js';
import Ticket from 'components/shared/theaters/ticketing/ticketComplete/ticket.js';
import s from 'components/shared/theaters/ticketing/ticketComplete/ticketComplete.sss';
import bb from 'components/shared/theaters/ticketing/bottomBar.sss';


export default class TicketComplete extends Component {

	constructor(props) {
		super(props);
		this.printTicket = this.printTicket.bind(this);
	}

	printTicket() {
		window.open(getPrintYourTicketUrl());
	}

	render(props) {
		const {
			ticketing, // Object - the current ticketing state
		} = props;

		// NOTE: We should always have a booking reference here
		const bookingRef = accessNested(ticketing, 'payment.bookingId', '-');

		return (
			<div class={joinClasses(props.class, s.stepContainer)}>
				<div class={s.stepInner}>
					<h1 class={s.header}>{getCopy('ENJOY_THE_FILM')}</h1>
					<p>{textToJsxArray(getCopy('TICKETING_COMPLETED_MESSAGE'))}</p>
					<h3>{getCopy('PICKUP_INFO')}</h3>
					<p>{getCopy('PICKUP_INFO_MESSAGE')}</p>
					<h3>{getCopy('BOOKING_REFERENCE')}: {bookingRef}</h3>
					<Ticket ticketing={ticketing} ref={($ref) => this.$ticket = $ref} />
				</div>
				<div class={bb.wrapper}>
					<div class={bb.info}>
						<span class={bb.textInfo}>{getCopy('ORDER_COMPLETED')}</span>
					</div>
					<div class={bb.buttonWrapper}>
						<button class={bb.button} onClick={this.printTicket} style={{ maxWidth: '255px' }}>{getCopy('PRINT_YOUR_TICKET')}</button>
					</div>
				</div>
			</div>
		);
	}

}
